module.exports = __webpack_public_path__ + "static/media/AI Similarity heading.8824e25b.svg";